import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {api_auth} from "../../services/api_config";
import { FcGoogle } from "react-icons/fc";
import { FaGithub } from "react-icons/fa";
import Divider from "@mui/material/Divider";
import Buttons from "../../utils/Buttons";
import InputField from "../InputField/InputField";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMyContext } from "../../store/ContextApi";
import { useEffect } from "react";
import { encryptPassword } from "../../utils/encryptPassword";

const Signup = () => {
  const apiUrl = process.env.REACT_APP_AUTH_API_URL;
  const [role, setRole] = useState();
  const [loading, setLoading] = useState(false);
  const { token } = useMyContext();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      email: "",
      password: "",
    },
    mode: "onTouched",
  });

  useEffect(() => {
    setRole("ROLE_USER");
  }, []);

  const onSubmitHandler = async (data) => {
    const { username, email, password } = data;
    const sendData = {
      username,
      email,
      password: await encryptPassword(password),
      role: [role],
    };

    try {
      setLoading(true);
      const response = await api_auth.post("/auth/public/signup", sendData);
      toast.success("Reagister Successful");
      reset();
      if (response.data) {
        navigate("/login");
      }
    } catch (error) {
      if (
        error?.response?.data?.message === "Error: Username is already taken!"
      ) {
        setError("username", { message: "username is already taken" });
      } else if (
        error?.response?.data?.message === "Error: Email is already in use!"
      ) {
        setError("email", { message: "Email is already in use" });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) navigate("/");
  }, [navigate, token]);

  return (
    <div className="auth-page">
      <form onSubmit={handleSubmit(onSubmitHandler)} className="auth-card">
        <div>
          <h1 className="auth-title">Register Here</h1>
          <p className="auth-subtitle">
            Enter your credentials to create new account
          </p>
          <div className="flex items-center justify-between gap-2 py-5">
            <a href={`${apiUrl}/oauth2/authorization/google`} className="auth-oauth-btn">
              <FcGoogle className="text-2xl" />
              <span className="hidden sm:inline">Google</span>
            </a>
            <a href={`${apiUrl}/oauth2/authorization/github`} className="auth-oauth-btn">
              <FaGithub className="text-2xl" />
              <span className="hidden sm:inline">GitHub</span>
            </a>
          </div>
          <Divider className="auth-divider font-semibold">OR</Divider>
        </div>

        <div className="flex flex-col gap-2 mt-4">
          <InputField
            label="UserName"
            required
            id="username"
            type="text"
            message="*UserName is required"
            placeholder="type your username"
            register={register}
            errors={errors}
          />
          <InputField
            label="Email"
            required
            id="email"
            type="email"
            message="*Email is required"
            placeholder="type your email"
            register={register}
            errors={errors}
          />
          <InputField
            label="Password"
            required
            id="password"
            type="password"
            message="*Password is required"
            placeholder="type your password"
            register={register}
            errors={errors}
            min={6}
          />
        </div>
        <Buttons
          disabled={loading}
          onClickhandler={() => {}}
          className="btn-primary w-full my-4"
          type="text"
        >
          {loading ? <span>Loading...</span> : "Register"}
        </Buttons>

        <p className="auth-text text-center">
          Already have an account?{" "}
          <Link className="auth-link" to="/login">Login</Link>
        </p>
      </form>
    </div>
  );
};

export default Signup;
